document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('[data-menu-toggle]');const m=document.querySelector('[data-mobile-menu]');if(b&&m){b.addEventListener('click',()=>{m.classList.toggle('open');b.setAttribute('aria-expanded',m.classList.contains('open')?'true':'false')})}document.documentElement.classList.remove('no-js')});


(function(){
  function updateProductForm(form){
    var script = form.querySelector('[data-variants-json]');
    var idInput = form.querySelector('[data-variant-id]');
    var button = form.querySelector('[data-add-to-cart]');
    var selectors = Array.prototype.slice.call(form.querySelectorAll('[data-option-selector]'));
    if(!script || !idInput || !button){ return; }
    var variants;
    try { variants = JSON.parse(script.textContent || '[]'); } catch(e) { variants = []; }
    if(!variants.length){ return; }
    var selected = selectors.map(function(select){ return select.value; });
    var match = variants.find(function(variant){
      return variant.options.every(function(option, index){ return option === selected[index]; });
    });
    if(match){
      idInput.value = match.id;
      button.disabled = !match.available;
      button.textContent = match.available ? 'Add to cart' : 'Sold out';
    } else {
      button.disabled = true;
      button.textContent = 'Unavailable';
    }
  }

  document.addEventListener('change', function(event){
    if(!event.target.matches('[data-option-selector]')){ return; }
    var form = event.target.closest('[data-product-form]');
    if(form){ updateProductForm(form); }
  });

  document.querySelectorAll('[data-product-form]').forEach(updateProductForm);
})();
